<template>
  <div>
    <DashboardHeader
      heading="Team"
      paragraph="Invite or delete members of your team"
    >
      <div class="flex items-center">
        <Button v-on:button-click="$router.push('/account/team/invite')">
          Invite team member
        </Button>
      </div>
    </DashboardHeader>

    <template v-if="loading">
      <Logo />
    </template>

    <template v-else>
      <TableToolbar
        @update-query="handleSearchChange"
        placeholder="Search by user's name"
      />
      <table class="table table-bordered">
        <thead>
          <th class="mb-xxs relative grey-background fs-sm">
            User
          </th>
          <th class="mb-xxs relative grey-background fs-sm">
            Email
          </th>
          <th
            class="mb-xxs text-center relative grey-background fs-sm"
            style="text-align: center"
          >
            Manage
          </th>
        </thead>
        <tbody>
          <tr v-if="showSelf" style="cursor: auto;">
            <td>
              {{ user.firstName + ' ' + user.lastName }}
            </td>
            <td>
              {{ user.email }}
            </td>
            <td style="text-align: center">
              <span
                @click="$router.push('/account/name')"
                style="cursor: pointer; color: #4d48e8;"
              >
                Edit
              </span>
            </td>
          </tr>
          <tr v-for="(user, i) in filteredUsers" :key="i" style="cursor: auto;">
            <td v-if="user.firstName">
              {{ user.firstName + ' ' + user.lastName }}
            </td>
            <td v-else>
              {{ user.name }}
            </td>
            <td>
              {{ user.email }}
            </td>
            <td
              v-if="user.firstName"
              @click="openModal(user.id)"
              style="text-align: center"
            >
              <span style="cursor: pointer; color: #4d48e8;">
                Delete
              </span>
            </td>
            <td
              v-else
              @click="resendInvite(user.id)"
              style="text-align: center"
            >
              <span style="cursor: pointer; color: #4d48e8;">
                Resend invite
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <Modal
        v-if="modalShowing"
        header="Delete user"
        body="This user will have their access revoked and will be removed from your team, are you sure you want to delete this user?"
        okText="Delete"
        cancelText="Close"
        @confirm="deleteUser"
        @cancel="modalShowing = false"
      />
    </template>
  </div>
</template>

<script>
import DashboardHeader from '@/components/Dashboard/DashboardHeader';
import TableToolbar from '@/components/Dashboard/TableToolbar';
import Logo from '@/components/SpinningLogo';
import Button from '@/components/DesignSystem/Button';
import Modal from '@/components/Modal';
import { mapGetters, mapState } from 'vuex';
import API from '@/utils/api/common';

export default {
  name: 'TeamTable',
  components: {
    TableToolbar,
    DashboardHeader,
    Logo,
    Button,
    Modal,
  },
  data() {
    return {
      search: '',
      modalShowing: false,
      users: [],
      toDelete: '',
    };
  },
  computed: {
    ...mapGetters(['user']),
    ...mapState(['loading']),
    filteredUsers() {
      return this.users.filter(user => {
        if (user.firstName) {
          return (
            user.firstName.toLowerCase().includes(this.search.toLowerCase()) ||
            user.lastName.toLowerCase().includes(this.search.toLowerCase())
          );
        } else {
          return user.name.toLowerCase().includes(this.search.toLowerCase());
        }
      });
    },
    showSelf() {
      return (
        this.user.firstName.toLowerCase().includes(this.search.toLowerCase()) ||
        this.user.lastName.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  async created() {
    const data = await API.getUsersByOrganization();
    this.users = data;
  },
  methods: {
    handleSearchChange(fields, value) {
      this.search = value;
    },
    openModal(userId) {
      this.modalShowing = true;
      this.toDelete = userId;
    },
    async deleteUser() {
      const success = await API.deleteUser(this.toDelete);

      if (success) {
        this.modalShowing = false;
        this.users = this.users.filter(user => {
          return user.id !== this.toDelete;
        });
        this.$store.dispatch('showUserMessage', {
          success: true,
          title: 'Success!',
          message: 'User deleted.',
        });
      }
    },
    async resendInvite(id) {
      const data = await API.resendUserInvite(id);
      if (data.status === 200) {
        this.$store.dispatch('showUserMessage', {
          success: true,
          title: 'Success!',
          message: 'Your invitation has been sent.',
        });
      } else {
        this.$store.dispatch('showUserMessage', {
          success: false,
          title: 'Oops!',
          message: 'Something went wrong while resending invitation',
        });
      }
    },
  },
};
</script>
